import { BREEDER_PROFILE_TOTAL_STEPS, Button, Card } from '@presentation/components';
import { Progress } from '@presentation/pages/MtLandingBreeder/components/Progress';
import { useTheme } from '@emotion/react';
import type { FC } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import * as Styled from './styled';
import type { AlertProps } from './types';

export const Alert: FC<AlertProps> = (props) => {
  const {
    title,
    content,
    loading,
    link,
    linkText,
    profileCurrentProgress,
    progress,
    showProfileProgress,
    theme,
    onClick,
    onDismissClick,
  } = props;

  const { color } = useTheme();
  const getBorderLeftColor = (): string => {
    if (theme === 'success') {
      return color.blue.default;
    }

    if (theme === 'warning') {
      return color.blue.lightBlue;
    }

    return color.light.shadeLighter;
  };

  return (
    <Card
      size="medium"
      containerProps={{
        style: {
          backgroundColor: 'white',
          boxShadow: '-1px 3px 16px rgba(149, 157, 165, 0.19)',
          borderStyle: 'solid',
          borderWidth: `1px 1px 1px ${theme ? '4px' : '1px'}`,
          borderColor: `#f0f0f0 #f0f0f0 #f0f0f0 ${theme ? getBorderLeftColor() : '#f0f0f0'}`,
          borderRadius: '4px',
        },
      }}
    >
      {onDismissClick && (
        <Styled.CloseButton onClick={onDismissClick}>
          <AiOutlineClose />
        </Styled.CloseButton>
      )}

      <Styled.Row>
        <Styled.Column width={linkText ? 70 : 100}>
          <Styled.Title>{title}</Styled.Title>
          <Styled.Text>{content}</Styled.Text>
        </Styled.Column>

        {!showProfileProgress && linkText && (
          <Styled.Column>
            <Button
              color="blue"
              size="small"
              shrink
              link={link}
              disabled={loading}
              onClick={onClick}
            >
              {linkText}
            </Button>
          </Styled.Column>
        )}
      </Styled.Row>

      {showProfileProgress && profileCurrentProgress && (
        <Styled.Row>
          <Styled.Column width={50} marginTop={18}>
            <>
              <Styled.ProgressValue>{progress}%</Styled.ProgressValue>
              <Progress current={profileCurrentProgress} total={BREEDER_PROFILE_TOTAL_STEPS} />
            </>
          </Styled.Column>

          {linkText && (
            <Styled.Column>
              <Button
                color="blue"
                size="small"
                shrink
                link={link}
                disabled={loading}
                onClick={onClick}
              >
                {linkText}
              </Button>
            </Styled.Column>
          )}
        </Styled.Row>
      )}
    </Card>
  );
};
